import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

// Pages for one role only: admin-only pages (Insights, Units,
// Admins) and charge-only pages (Report Sheets and individual report sheets,
// which admins must never see). Anyone else is sent to their Overview. This
// only shapes the UI: the backend enforces the role on every route.
const RequireRole = ({ role, children }) => {
  const { nurse } = useAuth();
  return nurse?.role === role ? children : <Navigate to="/" replace />;
};

export default RequireRole;
